import { axios } from '@Root/API'

export const edit = ({ id, email }) => {
	return axios.put(`update/admin/notification/${id}`, { email })
}
